import { forgot_user_password } from '../services/user.mjs';

const check_inputs = () => {
  $('.slds-has-error').removeClass('slds-has-error').find('.slds-form-element__help').addClass('slds-hide');
  $('#error-notify').addClass('slds-hide');
  const email = $('#user-email-input').val();
  let email_ok = true;
  if (email === '') {
    email_ok = false;
    $('#error-message-email').text(`L'email doit être renseigné.`).removeClass('slds-hide').parent().addClass('slds-has-error');
  }

  if (!email_ok) {
    return;
  }
  do_forgot_password(email);
};

const do_forgot_password = async (email) => {
  try {
    const res_forgot = await forgot_user_password(email);
    if (res_forgot.success) {
      $('#card-bodyinner')
        .empty()
        .append(
          $(`
      <div class="slds-text-heading_small" style="display:inline-block;">${res_forgot.message_fr}</div>
      `)
        );
    } else {
      $('#error-notify-content')
        .empty()
        .append(
          $(`
      <h2>Erreur de demande de réinitialisation de mot de passe</h2>
      <p>${res_forgot.message_fr}</p>
      `)
        );
      $('#error-notify').removeClass('slds-hide');
    }
  } catch (error) {
    console.error('Do something with this error', error);
  }
};

const setup_listeners = () => {
  $('#validateBtn').on('click', () => {
    check_inputs();
  });
};

const run = () => {
  setup_listeners();
};
run();
